<template>
  <div id="myChartPie4" :style="{ width: '100vw', height: '270px' }"></div>
</template>

<script>
export default {
  props: ["otherPieData1"],
  data() {
    return {
      otherPieData: [],
    };
  },
  watch: {
    otherPieData1(newvalue, oldvalue) {
      this.otherPieData = newvalue;
      this.drawLinePie3();
    },
  },
  methods: {
    drawLinePie3() {
      let data = [
        { value: (this.otherPieData[0] / 10000).toFixed(2), name: "实收保费" },
        { value: (this.otherPieData[1] / 10000).toFixed(2), name: "应收保费" },
      ];
      let myChartPie4 = this.$echarts.init(
        document.getElementById("myChartPie4")
      );
      let option = {
        color: ["#2A8CF1", "#2DD18F"],
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          icon: "circle",
          bottom: "bottom",
          data: data,
          formatter: function (name) {
            let total = 0;
            let target;
            for (let i = 0, l = data.length; i < l; i++) {
              total += data[i].value;
              if (data[i].name == name) {
                target = data[i].value;
              }
            }
            if (name == "实收保费") {
              let arr = ["{a|" + target + "万" + "}", "{k|" + name + "}"];
              return arr.join("\n");
            } else {
              let arr = ["{b|" + target + "万" + "}", "{k|" + name + "}"];
              return arr.join("\n");
            }
          },
          textStyle: {
            rich: {
              k: {
                padding: [0, 0, 0, 0],
                lineHeight: 25,
                color: "#181818",
              },
              a: {
                color: "#2A8CF1",
                verticalAlign: "top",
                align: "center",
                padding: [0, 0, 0, 0],
              },
              b: {
                verticalAlign: "top",
                align: "center",
                padding: [0, 0, 0, 0],
                color: "#2DD18F",
              },
            },
          },
        },
        series: [
          {
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: "{d}%",
                },
                labelLine: { show: true, length: 1 },
              },
            },

            type: "pie",
            radius: ["47%", "70%"],
            center: ["50%", "40%"],
            data,
            label: { show: false },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      myChartPie4.setOption(option);
    },
  },
  mounted() {
    // setTimeout(() => {
    //   this.drawLinePie3();
    // }, 1000);
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/operationSummary/components/pieChartFour.vue